import api from "./api";

// Capa de servicios API del dominio "settings" (configuración global) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- Genéricos por clave ---
export const listSettings = () => api.get("/settings");
export const getSetting = (key, config) => api.get(`/settings/${key}`, config);
export const updateSetting = (key, payload) =>
  api.put(`/settings/${key}`, payload);

// --- Sub-endpoints específicos ---
export const getTimezone = (config) => api.get("/settings/timezone", config);
export const listTimezones = () => api.get("/settings/timezones");
export const getCurrency = () => api.get("/settings/currency");
export const getWebInfo = () => api.get("/settings/web-info");
export const getRegistrationStatus = (config) =>
  api.get("/settings/registration-status", config);

// --- Logos / media ---
export const getLogos = () => api.get("/settings/logos");
export const uploadLogo = (formData, config) =>
  api.post("/settings/logo", formData, config);
export const uploadSettingMedia = (ref, formData) =>
  api.post(`/settings/media-upload?ref=${ref}`, formData);
// Doc 0446: imagen de fondo de la pantalla de acceso.
export const deleteLoginBackground = () => api.delete("/settings/logo/login-fondo");
